import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import whyGsmImage from '../../assets/images/home/whygsm.png';

const WhyGSM = () => {
  const benefits = [
    'Great quality and brands',
    'World class shopping experience',
    'Seamless supply-chain infrastructure',
    'Value for money through competitive prices',
    'Superior customer experience and service',
    'Irresistible discounts and offers',
    'Vast network of store locations to suit your convenience'
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-center">
          <div className="col-span-2">
            <h2 className="text-2xl font-bold mb-6">Why Buy at Grace supermarket ?</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-2">
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    className="text-green-600 mt-1 flex-shrink-0 bg-white rounded-full"
                  />
                  <span className="text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <img
              src={whyGsmImage}
              alt="Fresh Groceries"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyGSM;